Vue.component('ack-shop-product', {
	delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
	template: '#ack-shop-product',
	created() {
		if (!this.hasSellingPlans) {
			this.priceInfo = this.product.variants[0].priceV2;
		}
	},
	mounted() {
		this.selectAvailableVariant();

		if (this.hasSellingPlans) {
			this.sellingPlansSelectValue = this.sellingPlans[0].id;
		}

		this.productChecked = this.productInitiallyChecked;

		EventBus.$on('unselect-all-products', () => {
			this.productChecked = false;
		});

		EventBus.$on('select-all-products', () => {
			if (!this.isPurchaseTemporarilyDisabled) {
				this.productChecked = true;
			}
		});
	},
	props: {
		product: {
			type: Object,
			required: true,
		},
		productInitiallyChecked: {
			type: Boolean,
			default: false,
		},
		isMobile: {
			type: Boolean,
			required: true,
		},
	},
	computed: {
		...Vuex.mapGetters('localization', ['currencySymbol', 'isAU_NZ', 'isUS_CA']),
		...Vuex.mapGetters('shop', ['currentCountryCode']),
		variants() {
			// Already filter the location from the shop-store by the location
			return this.product.variants;
		},

		sellingPlans() {
			return this.product.sellingPlanGroups[0]?.sellingPlans;
		},

		hasVariants() {
			return this.variants.length > 1;
		},

		hasSellingPlans() {
			return this.product.sellingPlanGroups.length > 0;
		},

		selectedVariant() {
			if (this.variantsSelectValue != null) {
				return this.variants.find((m) => {
					return m.id == this.variantsSelectValue;
				});
			} else {
				return this.variants[0];
			}
		},

		priceLabel() {
			// subsribe product
			if ((this.priceInfo && parseFloat(this.priceInfo.amount) === 0) || this.isSoldOut) {
				return 'Sold Out';
			}
			// normal product
			if (!this.hasSellingPlans && this.stock === 0) {
				return 'Sold Out';
			}
			return this.priceInfo
				? `${this.priceInfo.currencyCode} ${this.currencySymbol}${new this.numeralFormatter(this.priceInfo.amount).format('0,0.00')}`
				: '';
		},

		price() {
			if (this.product != null) {
				return parseFloat(this.selectedVariant.priceV2.amount);
			}
			return 0;
		},

		stock() {
			if (this.product != null) {
				return parseInt(this.selectedVariant.quantityAvailable);
			}

			return 0;
		},

		getImage() {
			const variant =
				this.product.variants.find((m) => m.id == this.variantsSelectValue) ||
				this.product.variants[0];
			return variant?.image?.src || this.product.img;
		},

		inventoryWarning() {
			let message = '';
			// Check the total inventory of the product
			if (this.product.totalInventory > 0 && this.product.totalInventory < 10) {
				message = `Low stock, possible delays`;
			}
			// Check the inventory of the selected variant
			let selectedVariant = this.product.variants.find((m) => m.id == this.variantsSelectValue);
			if (
				selectedVariant &&
				selectedVariant.quantityAvailable > 0 &&
				selectedVariant.quantityAvailable < 10
			) {
				message = `Low stock, possible delays`;
			}
			return message;
		},

		restrictedProductIds() {
			return [
				'gid://shopify/Product/6627055435879', // CURO Crown
				'gid://shopify/Product/6624780812391', // CURO Model
				'gid://shopify/Product/6624785760359', //CURO proDenture
				'gid://shopify/Product/6627062448231', // CURO ProSplint Soft
			];
		},

		soldOutProductIds() {
			return [];
		},
		isRestricted() {
			const restrictedProductIds = this.restrictedProductIds;
			const currentCountryCode = this.currentCountryCode
				? this.currentCountryCode.toUpperCase()
				: '';

			return (
				restrictedProductIds.includes(this.product.id) &&
				(currentCountryCode === 'US' || currentCountryCode === 'CA')
			);
		},
		isSoldOut() {
			const soldOutProductIds = this.soldOutProductIds;
			return soldOutProductIds.includes(this.product.id);
		},
		isPurchaseTemporarilyDisabled() {
			return isProductPurchaseTemporarilyDisabled(this.product.id);
		},
		isUnableToBuy() {
			return this.stock <= 0 || this.isSoldOut || this.isPurchaseTemporarilyDisabled;
		},
	},
	data() {
		return {
			pageId: 'shop-product',
			variantsSelectValue: null,
			sellingPlansSelectValue: null,
			productChecked: false,
			numeralFormatter: numeral,
			priceInfo: null,
			loading: false,
			userStockNotifyInfo: {
				email: '',
				userCountry: '',
				requestProduct: {
					id: '',
					name: '',
					variant: {
						name: '',
						id: '',
					},
				},
			},
			isSendingNotification: false,
			emailError: '',
		};
	},
	methods: {
		...Vuex.mapActions('shop', ['addToCartFromProperties', 'buyNow', 'getProductPrice']),

		productPrice() {
			this.loading = true;
			this.getProductPrice({
				variantId: this.selectedVariant.id,
				sellingPlanId: this.sellingPlansSelectValue,
			})
				.then((priceInfo) => {
					if (priceInfo) {
						this.priceInfo = priceInfo;
					}
					this.loading = false;
				})
				.catch((error) => {
					console.error('Error fetching price:', error);
					this.loading = false;
				});
		},
		setVariantPrice() {
			if (!this.hasVariants || this.hasSellingPlans) return;
			this.priceInfo = this.selectedVariant.priceV2;
		},
		onBuyNowClick() {
			if (this.isPurchaseTemporarilyDisabled) return;

			if (this.stock !== 0 && !this.isRestricted && this.isSoldOut) {
				alert('This product is sold out.');
			} else {
				this.buyNow({
					variantId: this.variantsSelectValue,
					sellingPlanId: this.sellingPlansSelectValue,
				}).then((url) => {
					openCheckoutUrl(url);
				});
			}
		},

		onAddToCartClick() {
			appLog.log('onAddToCartClick', LOG_TYPE.debug);
			const shopifyId = this.product.id;
			const variantId = this.variantsSelectValue;
			const sellingPlanId = this.sellingPlansSelectValue;
			appLog.log({ shopifyId, variantId, sellingPlanId }, LOG_TYPE.debug);

			if (this.isRestricted) {
				alert('This product is not available in your region.');
				return;
			}

			if (this.isSoldOut) {
				alert('This product is sold out.');
				return;
			}

			this.addToCartFromProperties({ productId: shopifyId, variantId, sellingPlanId });
		},

		toggleExpand() {
			this.isExpanded = !this.isExpanded;
		},

		selectAvailableVariant() {
			let availableVariant = this.variants.find((variant) => variant.quantityAvailable > 0);
			if (availableVariant) {
				this.variantsSelectValue = availableVariant.id;
			} else {
				this.variantsSelectValue = this.variants[0].id;
			}
		},
		validateEmail(email) {
			const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
			return emailRegex.test(email);
		},
		setUserStockNotifyInfoData() {
			const { id, title, variants } = this.product;
			const hasMultipleSellingPlans = this.hasSellingPlans && this.sellingPlans.length > 1;

			let variantId = '';
			let variantName = '';

			if (this.hasVariants) {
				variantId = this.variantsSelectValue;
				variantName = this.selectedVariant.title;
			} else if (hasMultipleSellingPlans) {
				variantId = this.sellingPlansSelectValue;
				const selectedPlan = this.sellingPlans.find(
					(sellingPlan) => sellingPlan.id === this.sellingPlansSelectValue,
				);
				variantName = selectedPlan ? selectedPlan.name : '';
			} else if (variants && variants.length > 0) {
				variantId = variants[0].id;
				variantName = variants[0].title;
			}

			this.userStockNotifyInfo.userCountry = this.currentCountryCode;
			this.userStockNotifyInfo.requestProduct.id = id;
			this.userStockNotifyInfo.requestProduct.name = title;
			this.userStockNotifyInfo.requestProduct.variant.id = variantId;
			this.userStockNotifyInfo.requestProduct.variant.name = variantName;
		},
		onUserStockNotifyClick() {
			const { email } = this.userStockNotifyInfo;

			if (!this.validateEmail(email)) {
				this.emailError = 'Please enter correct Email';
				return;
			}
			this.emailError = '';
			this.setUserStockNotifyInfoData();
			this.sendStockAlertRequest();
		},
		showAlert(alertType, message) {
			let alertToBeShown = {
				success: {
					title: 'Request Confirmed!',
					text: 'We will email you as soon as this product is back in stock.',
					icon: 'success',
					confirmButtonText: 'ok',
				},
				failed: {
					icon: 'error',
					title: 'Request Unsuccessful',
					text: message,
				},
			};
			if (!alertToBeShown[alertType]) return;
			Swal.fire(alertToBeShown[alertType]);
		},
		sendStockAlertRequest() {
			this.isSendingNotification = true;

			fetch('https://dashboard.ackuretta.com/api/Shopify/stock_notify', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify(this.userStockNotifyInfo),
			})
				.then((response) => {
					this.isSendingNotification = false;
					if (!response.ok) {
						return response.json().then((errBody) => {
							throw {
								status: response.status,
								statusText: response.statusText,
								body: errBody,
							};
						});
					}
					return response.json();
				})
				.then((data) => {
					console.log('Response:', data);
					this.showAlert('success');
					this.userStockNotifyInfo.email = '';
				})
				.catch((err) => {
					this.isSendingNotification = false;
					let errMessage = 'Something went wrong! Please try again.';
					if (err.status === 409) {
						errMessage = 'You have already requested a stock notification with this email address.';
					}
					this.showAlert('failed', errMessage);
				});
		},
	},
	beforeDestroy() {},
	watch: {
		sellingPlansSelectValue: 'productPrice',
		variantsSelectValue: 'setVariantPrice',
		productChecked: {
			handler() {
				appLog.log(`productChecked change to ${this.productChecked}`);
				if (this.productChecked && this.isPurchaseTemporarilyDisabled) {
					this.productChecked = false;
					return;
				}

				if (this.productChecked == true) {
					let sellingPlanTitle = null;
					if (this.sellingPlansSelectValue) {
						let sellingPlan = this.product.sellingPlanGroups[0].sellingPlans.find((m) => {
							return m.id == this.sellingPlansSelectValue;
						});

						sellingPlanTitle = sellingPlan.name;
					}

					let variantTitle = '';
					if (this.variantsSelectValue) {
						let variant = this.product.variants.find((m) => {
							return m.id == this.variantsSelectValue;
						});

						variantTitle = variant.title;

						if (variantTitle === 'Default Title') {
							variantTitle = '';
						}
					}

					this.$emit('product-selected', {
						productId: this.product.id,
						variantId: this.variantsSelectValue,
						sellingPlanId: this.sellingPlansSelectValue,
						img: this.getImage,
						pricePerUnit: this.price,
						quantity: 1,
						productTitle: this.product.title,
						sellingPlanTitle: sellingPlanTitle,
						variantTitle: variantTitle,
					});
				} else {
					this.$emit('product-unselected', {
						productId: this.product.id,
						variantId: this.variantsSelectValue,
						sellingPlanId: this.sellingPlansSelectValue,
						img: this.getImage,
						pricePerUnit: this.price,
						quantity: 1,
					});
				}
			},
			deep: false,
		},
		isMobile: {
			handler() {},
			deep: false,
		},
	},
});
